import { useEffect } from "react";
import api from "@/components/customAxios/Axios";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/toast";
import { useLoader } from "@/context/loaderContext";
const Payment = () => {
	const { setLoading } = useLoader();
	const navigate = useNavigate();
	const toast = useToast();
	const paymentDetails = {
		companyId: localStorage.getItem("companyId"),
		amount: localStorage.getItem("amount") || "0",
		planId: localStorage.getItem("planId"),
	};
	const payment = async (amountPaid: string | null) => {
		try {
			setLoading(true);
			const response = await api.post("/store_payment_details", {
				company_id: paymentDetails.companyId,
				user_id: localStorage.getItem("user"),
				subscription_plan_id: paymentDetails.planId,
				amount_paid: amountPaid
			});

			if (response.status === 201) {
				localStorage.setItem("isCompanyAdmin", "true");

				localStorage.setItem("role", "Talentick_admin");
				localStorage.removeItem("plan");
				localStorage.removeItem("planId");
				localStorage.removeItem("amount");
				navigate("/settings");

				toast.success({
					type: "background",
					duration: 3000,
					status: "Success",
					title: "Payment successful",
					description: "Your payment has been processed successfully.",
					open: true,
				});
			}
		} catch (error: any) {
			console.log(error);
			// setLoading(false);
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error Occurred",
				description: error.response?.data?.error || error.response?.data?.message || "An unknown error occurred",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};
	// Razorpay payment initiation function
	const initiatePayment = async () => {
		try {
			// Call your Flask backend to create the Razorpay order
			const response = await api.post("/create-order", {
				subscription_plan_id: localStorage.getItem("planId"),
				user_id: localStorage.getItem("user")

			});

			const { orderId, amount, key_id, company_details, total_amount } = response.data;

			// Load the Razorpay checkout script
			const script = document.createElement("script");
			script.src = "https://checkout.razorpay.com/v1/checkout.js";
			script.async = true;
			document.body.appendChild(script);

			script.onload = () => {
				const options = {
					key: key_id, // Your Razorpay key (from backend)

					amount: parseInt(amount) * 100, // Convert dollars to cents
					currency: "USD",
					name: "Test Payment",
					description: "Payment for subscription",
					order_id: orderId, // Razorpay order ID
					handler: function () {
						payment(total_amount);
					},
					prefill: {
						name: company_details.name,
						email: company_details.email,
						contact: company_details.phone,
					},
					theme: {
						color: "#F37254",
					},
					modal: {
						ondismiss: function () {
							// Redirect to /settings on modal close
							navigate("/settings");
						},
					},
				};

				const razorpay = new (window as any).Razorpay(options);
				razorpay.open();
			};
		} catch (error: any) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error Occurred",
				description:
					error.response?.data?.error || error.response?.data?.message ||
					"An error occurred, please try again later.",
				open: true,
			});
			navigate("/settings");
		}
	};

	useEffect(() => {
		if (
			paymentDetails.companyId &&
			paymentDetails.planId
		) {
			initiatePayment();
		} else {
			navigate("/settings");
		}
	}, []);
	return <></>;
};

export default Payment;
